import { Calendar } from "react-big-calendar";
import Slider from "react-slick";


export const WEEKDAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export const SliderCustom : any = Slider

export const CalendarCustom : any = Calendar 
